import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {Playbook} from "../types.ts";
import {I18n} from "@aws-amplify/core";


export const usePlaybooksTableColumns = () => {

    // FNP-565: `sortable` drives the clickable header; the comparator is
    // useTableSort in usePlaybooks, and the table's sortStatus /
    // onSortStatusChange wire the two together. All three parts are required —
    // `sortable` alone renders a header that looks clickable and does nothing,
    // which is worse than no sorting at all.
    //
    // `accessor` is what sorting sorts BY; `render` only controls how the cell
    // looks. Both columns keep a real accessor, so sorting Name sorts on the
    // name rather than on the NavLink element.
    const columns: DataTableColumn<Playbook>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            sortable: true,
            render: (item: Playbook) => <NavLink to={`/playbooks/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            sortable: true,
            render: (item: Playbook) => formatTimestamp(item.created),
        },
    ];


    return {
        columns,
    };
};
